import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';
import { OrderProviderExternalErrorRatioChartDataset } from 'types/embedded/orderProviderExternalErrors';

import {
  OrderProviderExternalErrorsRatioChartBarTitle,
  StyledLinearProgress,
} from './OrderProviderExternalErrorsRatioChart.styled';

type Props = OrderProviderExternalErrorRatioChartDataset & {
  title?: string;
};

export const OrderProviderExternalErrorsRatioChartBar: React.FC<Props> = ({
  title,
  provider,
  errors,
  orders,
  percentageRatio,
}) => {
  const translate = useTypedTranslate();
  return (
    <Box>
      <OrderProviderExternalErrorsRatioChartBarTitle>
        <Typography fontSize="12px">{title || provider}</Typography>
        <Typography color="text.secondary" fontSize="12px">
          <Typography
            color="error"
            component="span"
            sx={{
              fontSize: '12px',
              fontWeight: 500,
              marginRight: '4px',
            }}
          >{`${percentageRatio}%`}</Typography>
          {`(${errors} ${translate('app.common.of')} ${orders})`}
        </Typography>
      </OrderProviderExternalErrorsRatioChartBarTitle>
      <StyledLinearProgress value={percentageRatio} variant="determinate" />
    </Box>
  );
};
